import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  teachers: [],
});

export const mutations = {
  SET_TEACHERS(state, payload) {
    state.teachers = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_TEACHERS({ commit }, options) {
    const { itemsPerPage, search = "", sortBy = [], sortDesc = [] } = options;

    const page = Number(options.page - 1) || 0;
    const sortField = sortBy.length ? sortBy[0] : "";
    const sortOrder = sortDesc.length && sortDesc[0] ? "desc" : "asc";

    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}&sortField=${sortField}&sortOrder=${sortOrder}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/teacher${query}`);
    if (data) {
      commit("SET_TEACHERS", data.content);
      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async ADD_TEACHER(ctx, teacher) {
    const url = "admin/teacher";
    const method = teacher.id ? "$post" : "$put";
    return await vm.$axios[method](url, teacher);
  },

  async DELETE_TEACHER(ctx, id) {
    return await vm.$axios.$delete(`admin/teacher/${id}`);
  },
};

export const getters = {
  GET_TEACHERS: (state) => state.teachers,
};
